import React from 'react'

import config from '../config.js'

import { Link } from 'react-router-dom'

const ListFriendUser = ({ user, friendsPath }) => (
  <li className="friends-list-item">
    <Link to={friendsPath + '/list/' + user.identifier + '/cookbooks'}>
      <img
        className="friends-list-item__img"
        src={
          user.avatarUrl == null
            ? config.baseUrl + '/assets/img/generic-avatar-medium.png'
            : user.avatarUrl + '=s96-c'
        }
        alt={user.name + ' Avatar'}
      />
    </Link>
    <h3 className="friends-list-item__name">
      <Link to={friendsPath + '/list/' + user.identifier + '/cookbooks'}>
        {user.name}
      </Link>
    </h3>
    <Link
      className="friends-list-item__link"
      to={friendsPath + '/list/' + user.identifier + '/cookbooks'}
    >
      View My Shared Recipes
    </Link>
  </li>
)

export default ListFriendUser



// WEBPACK FOOTER //
// ./src/Components/ListFriendUser.js